module.exports = __webpack_public_path__ + "static/media/STS_IMAGE.2b123c4a.png";